import React, { useState } from "react";
import "../../../assets/css/customer/shop/subscreens/pd_ProductTabs.css";

const ProductTabs = ({ product }) => {
  const [activeTab, setActiveTab] = useState("description");

  // keyFeatures is stored as a comma-separated string — split into a clean list
  const keyFeaturesList = (product.keyFeatures || "")
    .split(",")
    .map((f) => f.trim())
    .filter(Boolean);

  return (
    <div className="pd-tabs">
      {/* Tab Headers */}
      <div className="pd-tab-headers">
        <button
          className={`pd-tab-header ${activeTab === "description" ? "pd-tab-active" : ""}`}
          onClick={() => setActiveTab("description")}
        >
          Description
        </button>
        <button
          className={`pd-tab-header ${activeTab === "specifications" ? "pd-tab-active" : ""}`}
          onClick={() => setActiveTab("specifications")}
        >
          Specifications
        </button>
      </div>

      {/* Tab Content */}
      <div className="pd-tab-content">
        {/* Description Tab */}
        {activeTab === "description" && (
          <div className="pd-tab-panel">
            <h3 className="pd-panel-title">Product Description</h3>
            <p className="pd-description-text">{product.description}</p>

            {keyFeaturesList.length > 0 && (
              <div className="pd-features-list">
                <h4>Key Features:</h4>
                <ul>
                  {keyFeaturesList.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        {/* Specifications Tab */}
        {activeTab === "specifications" && (
          <div className="pd-tab-panel">
            <h3 className="pd-panel-title">Technical Specifications</h3>
            <table className="pd-spec-table">
              <tbody>
                {product.dimensions && (
                  <tr>
                    <td className="pd-spec-label">Dimensions</td>
                    <td className="pd-spec-value">{product.dimensions}</td>
                  </tr>
                )}
                {product.material && (
                  <tr>
                    <td className="pd-spec-label">Material</td>
                    <td className="pd-spec-value">{product.material}</td>
                  </tr>
                )}
                {product.color && (
                  <tr>
                    <td className="pd-spec-label">Color</td>
                    <td className="pd-spec-value">{product.color}</td>
                  </tr>
                )}
                {product.size && (
                  <tr>
                    <td className="pd-spec-label">Size</td>
                    <td className="pd-spec-value">{product.size}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductTabs;
